export { default } from './Icon';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Icon/index.js
// module id = 801
// module chunks = 121